/* Agathe Kattegat : vidéos, carrousel d'ingrédients, scène interactive, apparitions. */
(() => {
  /* Accueil : en-tête transparent tant qu'on n'a pas défilé, + mesures pour la vidéo plein écran */
  const root = document.documentElement;
  if (root.classList.contains('ak-home')) {
    const measure = () => {
      const h = document.querySelector('.section-header');
      const bar = document.querySelector('.announcement-bar-section, #shopify-section-announcement-bar');
      if (h) root.style.setProperty('--ak-header-h', h.offsetHeight + 'px');
      root.style.setProperty('--ak-bar-h', (bar ? bar.offsetHeight : 0) + 'px');
    };
    const onScroll = () => root.classList.toggle('ak-scrolled', window.scrollY > 24);
    measure(); onScroll();
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', measure);
    addEventListener('load', measure);
  }

  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const mobile = matchMedia('(max-width: 749px)');

  /* Vidéos : une version bureau, une version mobile */
  function initVideos(root) {
    root.querySelectorAll('video[data-ak-video]').forEach(v => {
      if (v.dataset.akInit) return;
      v.dataset.akInit = '1';
      const set = () => {
        const src = mobile.matches && v.dataset.mobile ? v.dataset.mobile : v.dataset.desktop;
        if (!src || v.dataset.cur === src) return;
        v.dataset.cur = src;
        v.src = src;
        v.load();
        if (!reduce) v.play().catch(() => {});
      };
      set();
      mobile.addEventListener('change', set);
    });
  }

  /* Bandeau d'ingrédients : fondu, points avec anneau de progression */
  function initCarousels(root) {
    root.querySelectorAll('[data-ak-carousel]').forEach(stage => {
      if (stage.dataset.akInit) return;
      stage.dataset.akInit = '1';
      const slides = [...stage.querySelectorAll('.ak-ing__slide')];
      const dots = stage.querySelector('.ak-ing__dots');
      const auto = stage.dataset.autoplay === 'true' && !reduce && slides.length > 1;
      let cur = 0;
      const paint = () => {
        if (slides.length < 2) { dots.hidden = true; return; }
        dots.innerHTML = slides.map((_, i) => `<button type="button" aria-label="Aller à l’élément ${i + 1}" aria-current="${i === cur}"><svg viewBox="0 0 8 8"><circle cx="4" cy="4" r="3.25"/><circle cx="4" cy="4" r="3.25"/></svg></button>`).join('');
        dots.querySelectorAll('button').forEach((b, i) => {
          b.addEventListener('click', () => go(i));
          if (i === cur && auto) b.querySelector('circle:last-child').addEventListener('animationend', () => go((cur + 1) % slides.length));
        });
      };
      const go = i => { cur = i; slides.forEach((s, k) => s.classList.toggle('is-on', k === i)); paint(); };
      stage.addEventListener('mouseenter', () => stage.classList.add('is-paused'));
      stage.addEventListener('mouseleave', () => stage.classList.remove('is-paused'));
      go(0);
    });
  }

  /* Scène interactive : points au-dessus des bouchons, traits en biais */
  function initScenes(root) {
    root.querySelectorAll('[data-ak-scene]').forEach(sec => {
      if (sec.dataset.akInit) return;
      sec.dataset.akInit = '1';
      const scene = sec.querySelector('.ak-scene');
      const card = sec.querySelector('.ak-pcard');
      const hots = [...scene.querySelectorAll('.ak-hot')];
      if (!hots.length) return;
      const DX = 7; /* décalage latéral du point, en % de la largeur */
      const side = h => (h.dataset.side === 'left' ? -1 : 1);
      hots.forEach(h => {
        h.style.left = (+h.dataset.x + side(h) * DX) + '%';
        h.style.top = (+h.dataset.y - +h.dataset.drop) + '%';
      });
      const layout = () => {
        const W = scene.clientWidth, H = scene.clientHeight;
        hots.forEach(h => {
          const vx = -side(h) * DX / 100 * W, vy = +h.dataset.drop / 100 * H;
          h.style.setProperty('--len', Math.hypot(vx, vy).toFixed(1) + 'px');
          h.style.setProperty('--a', (Math.atan2(-vx, vy) * 180 / Math.PI).toFixed(1) + 'deg');
        });
      };
      new ResizeObserver(layout).observe(scene);
      layout();
      const img = card.querySelector('[data-pc-img]'), name = card.querySelector('[data-pc-name]');
      const price = card.querySelector('[data-pc-price]'), link = card.querySelector('[data-pc-link]');
      const fill = h => {
        if (h.dataset.img) { img.src = h.dataset.img; img.alt = h.dataset.name; img.hidden = false; } else { img.hidden = true; }
        name.textContent = h.dataset.name;
        price.textContent = h.dataset.price;
        if (h.dataset.btn) link.textContent = h.dataset.btn;
        if (h.dataset.url) { link.href = h.dataset.url; link.hidden = false; } else { link.hidden = true; }
      };
      let current = -1;
      const pick = i => {
        if (i === current) return;
        current = i;
        hots.forEach((h, k) => h.setAttribute('aria-pressed', String(k === i)));
        if (reduce) { fill(hots[i]); return; }
        card.classList.add('is-swap');
        setTimeout(() => { fill(hots[i]); card.classList.remove('is-swap'); }, 160);
      };
      hots.forEach((h, i) => {
        h.addEventListener('click', () => pick(i));
        h.addEventListener('mouseenter', () => pick(i));
        h.addEventListener('focus', () => pick(i));
      });
      pick(0);
    });
  }

  /* Apparition des photos au défilement (zoom arrière, fondu) */
  let seen;
  function initReveal(root) {
    if (reduce || !('IntersectionObserver' in window) || !document.documentElement.classList.contains('ak-anim')) return;
    seen = seen || new IntersectionObserver(es => es.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('is-shown'); seen.unobserve(e.target); }
    }), { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });
    root.querySelectorAll('[data-ak-zoom], [data-ak-fade]').forEach(el => seen.observe(el));
  }

  const init = root => { initVideos(root); initCarousels(root); initScenes(root); initReveal(root); };
  init(document);
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
